import anotherDay from '../images/vinyl.jpeg'
import redShirt from '../images/redshirtimage.png'
import whiteShirt from '../images/CD.jpeg'
import possumShirt from '../images/possumart.png'

const albumData = [
  {
    title: 'Vinyl Record',
    image: anotherDay,
    id: '1',
    year: 'February 2026',
    link: 'https://ashevillemountainboys.bandcamp.com/merch',
    description:
      'Sober Again released August 6th, 2021. Currently spinning on Folk Radio and streaming on all platforms.',
  },

  {
    title: 'CD',
    image: whiteShirt,
    id: '3',
    year: 'February 2026',
    link: 'https://ashevillemountainboys.bandcamp.com/merch',
  },
  {
    title: 'Possum T-Shirt',
    image: possumShirt,
    id: '2',
    year: '',
    link: 'https://ashevillemountainboys.bandcamp.com/merch',
    description: 'possum playing a banjo',
  },
  {
    title: 'Red T-Shirt',
    image: redShirt,
    id: '4',
    link: 'https://ashevillemountainboys.bandcamp.com/merch',
    year: '',
  },
]

export default albumData
